export default __webpack_public_path__ + "static/key-findings-figure-2-2025-6a1d0b27fc09c7f533bcb25f508fb5d7.png";